import { render, staticRenderFns } from "./SwitcherTextOptions.vue?vue&type=template&id=8341513c&scoped=true&"
import script from "./SwitcherTextOptions.vue?vue&type=script&lang=ts&"
export * from "./SwitcherTextOptions.vue?vue&type=script&lang=ts&"
import style0 from "./SwitcherTextOptions.vue?vue&type=style&index=0&id=8341513c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8341513c",
  null
  
)

export default component.exports